import { withFadeTransition } from "../../../../StoreComponents/StoreTransition";
import ActivityRewardList from "./components/ActivityRewardList";

const Activity = () => {
  return <ActivityRewardList />;
};

export default withFadeTransition(Activity);
